import { useTranslation } from 'react-i18next';

import { OnboardingStyle } from '../onboarding/onboarding-style';
import { AuthHeader, ContentLayout } from '../../../global-styles/layout';
import { Heading2Text } from '../../../components/typography/typography';
import { images } from '../../../assets/images/images';
import { CancelledStyles } from './cancelled-style';

const Cancelled = () => {
  const { t } = useTranslation(['common', 'cancelled']);

  return (
    <ContentLayout data-cy="cancelled-page">
      <CancelledStyles>
        <OnboardingStyle>
          <div className="onboarding-top">
            <AuthHeader>
              <div className="auth-header-title">
                <Heading2Text as="h1" weight={600}>
                  {t('cancelled:title')}
                </Heading2Text>
              </div>
              <div className="auth-header-title">
                <Heading2Text as="h2" weight={600}>
                  {t('cancelled:text')}
                </Heading2Text>
              </div>
            </AuthHeader>
            <div className="cancelled-img">
              <img src={images.cars} alt="" />
            </div>
          </div>
        </OnboardingStyle>
      </CancelledStyles>
    </ContentLayout>
  );
};

export default Cancelled;
